export default __webpack_public_path__ + "static/media/ic-channel-black.7e4f0416.svg";